import { useEffect, useState } from 'react';
import { teacherAnalyticsAPI } from '../api/teacherAnalyticsAPI';

/**
 * GET /api/teacher-analytics/chat-summary for the Overview card.
 * Starts as soon as the tab is enabled. It does not wait on the tracker payload.
 */
const useChatSummary = ({ scope, period, enabled }) => {
  const [attempt, setAttempt] = useState(0);
  const [state, setState] = useState({ status: 'loading', data: null, error: '' });

  useEffect(() => {
    if (!enabled || !scope) return undefined;
    let cancelled = false;
    setState({ status: 'loading', data: null, error: '' });
    teacherAnalyticsAPI.getChatSummary({ period, scope })
      .then((data) => {
        if (!cancelled) setState({ status: 'ready', data, error: '' });
      })
      .catch(() => {
        if (!cancelled) setState({ status: 'error', data: null, error: 'Could not load chat. Please try again.' });
      });
    return () => { cancelled = true; };
  }, [enabled, scope, period, attempt]);

  return { ...state, retry: () => setAttempt((value) => value + 1) };
};

export default useChatSummary;
